export function generateDownloadLink(
  blob: Blob,
  fileName: string,
  shouldClick = false,
): HTMLAnchorElement {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.setAttribute("download", fileName);
  a.download = fileName;
  window.document.body.appendChild(a);
  if (shouldClick) {
    a.click();
    window.document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  return a;
}
